// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"104":"individual-offers","130":"basket","205":"favorites","901":"archives","908":"history"}[chunkId] || chunkId) + "." + {"29":"b4bdbbc3","104":"d5d27b46","130":"55105628","205":"8bab10ac","496":"4cecf109","623":"7182e5ac","901":"c57b001a","908":"e0531ae2"}[chunkId] + ".chunk.js";
};